import React from "react";
import firebase from "../../../lib/firebase";
import sanitizeHtml from "sanitize-html";
import prettyDate from "pretty-date";
import _ from "lodash";
import "./LiveList.css";


export default class LiveList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            liveData: []
        };
    }

    componentDidMount() {
        this.startLive();
    }

    componentWillUnmount() {
        this.stopLive();
    }

    stopLive() {
        if (this.liveEventHandler) {
            firebase.database().ref(`campaign/${this.props.campaignId}/events`).off('child_added', this.liveEventHandler);
        }
    }

    startLive() {


        firebase.database().ref(`campaign/${this.props.campaignId}/events`).limitToLast(100).once('value').then(function (sp) {
            var data = [];
            sp.forEach(function (e) {
                data.push(Object.assign({}, e.val(), {key: e.key}));
            });
            data.sort(function (o1, o2) {
                return o2.updated - o1.updated;
            });
            this.setState({
                liveData: data
            }, function () {
                this.liveEventHandler = firebase.database().ref(`campaign/${this.props.campaignId}/events`).limitToLast(1).on('child_added', function (sp) {
                    let newArray = Object.assign([], this.state.liveData);
                    if (_.find(newArray, {key: sp.key})) {
                        return false;
                    }
                    newArray.unshift(Object.assign(sp.val(), {key: sp.key}));
                    this.setState({
                        liveData: newArray
                    });
                }.bind(this));
            }.bind(this));
        }.bind(this));


    }

    render() {
        let list = this.state.liveData.map(function (e, i) {
            return (
                <li
                    key={e.key}
                >
                    <div className="profileImg">
                        <div style={{backgroundImage: 'url(' + e.photoURL + ')'}}></div>
                    </div>
                    <div className="info">
                        <div className="displayName">
                            {e.displayName}&nbsp;&nbsp;
                        </div>
                        <div className="meta">
                            {<span
                                dangerouslySetInnerHTML={{__html: sanitizeHtml(e.title)}}/>
                            } | {prettyDate.format(new Date(e.updated))}
                        </div>
                        <div className="msg"
                             dangerouslySetInnerHTML={{__html: sanitizeHtml(e.msg)}}/>
                    </div>

                </li>
            );
        });
        return <div className="LiveList">
            <ul style={{padding: 0, margin: 0}}>
                {list}
            </ul>
            {/*<FlatButton label="더보기"/>
            <div style={{height:'44px', visibility:'hidden'}}>hi</div>*/}
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/container/campaign/component/LiveList.js